import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { videoService } from '../services/api';
import './VideoPlayer.css';

const VideoPlayer = () => {
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const videoRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        // Get video metadata
        const videoData = await videoService.getVideo(id);
        setVideo(videoData);
        setLoading(false);
      } catch (err) {
        console.error('Error loading video metadata:', err);
        setError(`Failed to load video: ${err.message}`);
        setLoading(false);
      }
    };

    fetchVideoData();
  }, [id]);

  useEffect(() => {
    if (!videoRef.current || !video) return;
    
    // Set up direct stream URL with token in query parameter
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No authentication token available');
      return;
    }
    
    // This approach uses query parameters which are simpler for video elements
    const encodedToken = encodeURIComponent(token);
    const videoUrl = `https://colinstebelski.com/api/stream/${id}?token=${encodedToken}`;
    
    // Set the video source
    videoRef.current.src = videoUrl;
    
  }, [id, video, videoRef]);

  const handleBack = () => {
    navigate('/videos');
  };

  if (loading) return <div className="page"><div className="loading">Loading video...</div></div>;
  if (error) return <div className="page"><div className="error">{error}</div></div>;
  if (!video) return <div className="page"><div className="error">Video not found</div></div>;

  return (
    <div className="page video-player-container">
      <h1>{video.title}</h1>
      <p className="video-date">{new Date(video.date).toLocaleDateString()}</p>
      
      <div className="video-player">
        <video 
          ref={videoRef}
          controls 
          preload="metadata"
          width="100%" 
          height="auto"
          controlsList="nodownload"
          playsInline
        >
          Your browser does not support the video tag.
        </video>
      </div>
      
      <div className="video-controls">
        <button onClick={handleBack} className="back-button">
          Back to Gallery
        </button>
      </div>
      
      <div className="video-description">
        <h3>About this video</h3>
        <p>{video.description}</p>
      </div>
    </div>
  );
};

export default VideoPlayer; 